import { ErrorHandlerCaller as EHC, DEFAULTS_HANDLERS } from "@/utils/errors"
import { HTTP } from "@/utils/http-common"

export default {
  getAll(projectId) {
    return new Promise((resolve, reject) => {
      HTTP.get(`/projects/${projectId}/inspections`)
        .then(response => resolve(response.data))
        .catch(err => {
          return reject(err)
        })
    })
  },

  get($, projectId = null, inspectionId = null, uuid = null) {
    return new Promise((resolve, reject) => {
      let root
      if (uuid) {
        root = `/projects/inspections/${uuid}`
      } else if (projectId) {
        root = `/projects/${projectId}/inspections${inspectionId ? "/" + inspectionId : ""}`
      } else {
        root = `/projects/inspections${inspectionId ? "/" + inspectionId : ""}`
      }
      HTTP.get(root)
        .then(response => resolve(response.data))
        .catch(err => {
          return reject(err)
        })
    })
  },

  async getAllInspections() {
    const path = `/projects/inspections`
    return (await HTTP.get(path)).data
  },

  remove($, inspectionId) {
    return new Promise((resolve, reject) => {
      HTTP.delete(`/projects/inspections/${inspectionId}`)
        .then(response => resolve(response.data))
        .catch(error => {
          new EHC(DEFAULTS_HANDLERS).intercept(error)
          reject(error)
        })
    })
  },

  create($, projectId, inspection) {
    return new Promise((resolve, reject) => {
      HTTP.post(`/projects/${projectId}/inspections`, inspection)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          new EHC(DEFAULTS_HANDLERS).intercept(error)
          reject(error)
        })
    })
  },
  update($, inspectionId, inspection) {
    return new Promise((resolve, reject) => {
      HTTP.patch(`/projects/inspections/${inspectionId}`, inspection)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          new EHC(DEFAULTS_HANDLERS).intercept(error)
          reject(error)
        })
    })
  },
  createInspection($, projectId, inspection) {
    return new Promise((resolve, reject) => {
      HTTP.post(`/projects/${projectId}/inspections`, inspection)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          let message = ""
          for (const err in error.response.data) {
            message += "- " + err + " : " + error.response.data[err] + "\n"
          }
          $.$store.commit("app/message", { msg: message, color: "error" })
          reject(error)
        })
    })
  },
  document: {
    async get($, inspectionId) {
      const path = `/documents/inspections/${inspectionId}`
      const response = (await HTTP.get(path)).data
      if (response.length > 0) {
        return response[0]
      } else {
        throw Error("No template linked")
      }
    },
    async post(inspectionId, data) {
      const path = `/documents/inspections/${inspectionId}`
      return (await HTTP.post(path, data)).data
    },
    async put(inspectionId, data) {
      const path = `/documents/inspections/${inspectionId}`
      return (await HTTP.put(path, data)).data
    }
  },
  unassignedPictures: {
    getAll(inspectionId) {
      return new Promise((resolve, reject) => {
        HTTP.get(`/projects/inspections/${inspectionId}/unassigned-pictures`)
          .then(response => resolve(response.data))
          .catch(err => {
            return reject(err)
          })
      })
    },
    create(inspectionId, data) {
      return new Promise((resolve, reject) => {
        HTTP.post(`/projects/inspections/${inspectionId}/unassigned-pictures`, data)
          .then(response => resolve(response.data))
          .catch(err => {
            return reject(err)
          })
      })
    }
  }
}
